(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[106],{

/***/ 38559:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farm",
      function () {
        return __webpack_require__(46632);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Farms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(12737);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(27857);
;// CONCATENATED MODULE: ./src/hooks/useFarms.ts



/**
 *
 * @param {Contract | null}contract
 * @return {farms[]}
 */ function useEmberFarms(contract) {
    const numberOfPools = (0,hooks/* useSingleCallResult */.Wk)(contract, "poolLength", undefined, {
        blocksPerFetch: 100
    });
    const args = (0,react.useMemo)(()=>{
        const { result , loading  } = numberOfPools;
        if (loading) {
            return;
        }
        return [
            ...Array(Number(result)).keys()
        ].map((pid)=>[
                String(pid)
            ]);
    }, [
        numberOfPools
    ]);
    const poolInfo = (0,hooks/* useSingleContractMultipleData */.es)(args ? contract : null, "poolInfo", args ? args : []);
    // const pairAddresses = useMemo(() => {
    // return poolInfo.map((data) => {
    //   const { result, loading } = data
    //   if (loading) return
    //   if (result) {
    //     return result['lpToken'] as string
    //   }
    //   return
    // })
    // }, [poolInfo])
    return (0,react.useMemo)(()=>{
        if (poolInfo && args) {
            return poolInfo.map((data, i)=>{
                const { result , loading  } = data;
                if (loading) return;
                if (result) {
                    // const { result:Token1Result, loading: Token1Loading } = token1Result[i]
                    // const { result: Token0Result, loading: Token0Loading } = token0Result[i]
                    //   if (Token0Loading || Token1Loading) return
                    //   if (Token1Result && Token0Result){
                    //   const [token0, token1] = (Token0Result[0] as Token).sortsBefore(Token1Result[0] as Token)
                    //           ? [Token0Result[0], Token1Result[0]]
                    //           : [Token1Result[0], Token0Result[0]]
                    return {
                        id: args[i][0],
                        lpToken: result[0],
                        // token0: token0 as Token,
                        // token1: token1 as Token,
                        allocPoint: parseInt(result[1].toString()),
                        lastRewardBlock: parseInt(result[2].toString()),
                        accEmberPerShare: parseInt(result[3].toString()),
                        depositFeeBP: result[4],
                        harvestInterval: parseInt(result[5].toString()),
                        totalLp: parseInt(result[6].toString())
                    } // }
                    ;
                }
                return;
            });
        }
        return;
    }, [
        args,
        poolInfo
    ]);
}
/**
 * @return {ReturnType}
 */ function useFarms() {
    return useEmberFarms((0,useContract/* useDistributorContract */.$O)());
}

;// CONCATENATED MODULE: ./src/pages/farm/index.tsx


/**
 * @return {any}
 */ function Farms() {
    const farms = useFarms();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: JSON.stringify(farms)
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(38559); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);